import React from 'react';
import { fetchUserEvents } from '../../data/fetch';
import { useStoredDataChanged } from './useStoredDataChanged';
import Loader from './Loader';


const LoadUserEvents = ({match, children}) => {
    useStoredDataChanged();
    return (
        <Loader skipSpinner={state => state.events.userEventsLoaded} promises={[fetchUserEvents()]}>
            {children}
        </Loader>
    );
};

export default LoadUserEvents;
